import { useContext, useState } from "react";
import { AppContext } from "../../scripts/context";
import { ButtonComponent } from "../NFTStatus";
import CardBody from "../NFTStatus/CardBody";
import Roket from "./Roket";
import Style from "./style";

export default function NFTStatusMobile() {
  const {
    state,
    nftItems,
    state: {
      contracts: {
        nft: {
          data: { seletedNFT },
        },
      },
    },
  } = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Style seletedNFT={seletedNFT} isOpen={isOpen}>
      <Roket onClick={() => setIsOpen(!isOpen)} />
      {isOpen && (
        <div className="content">
          <div className="title">
            <div>
              <h3>Increase your Earning</h3>
              <span>Potential of Staking Rewards</span>
            </div>
            <span className="amount">+10%</span>
          </div>
          <div className="card-custom-body">
            <CardBody />
          </div>
          {(!state.contracts.nft.data.lockedNFT?.tokenID && !state.contracts.nft.data.seletedNFT && nftItems.length > 0)
            && (
              <span className="or">Or</span>
            )}
          <div className="card-custom-footer">
            <ButtonComponent />
          </div>
        </div>
      )}
    </Style>
  );
}
